import {
  DEFAULT_DEMOGRAPHIC_SETTINGS,
  type DemographicSettings,
} from '@/components/features/AudienceTargeting/DemographicTargeting';

export type ChannelStrategy = 'ALL_CHANNELS' | 'ALL_OWNED_AND_OPERATED_CHANNELS' | 'SELECTED_CHANNELS';

export interface DemandGenChannelSettings {
  channelStrategy: ChannelStrategy;
  // Individual channel toggles (only used when channelStrategy is SELECTED_CHANNELS)
  youtubeInStream: boolean;
  youtubeInFeed: boolean;
  youtubeShorts: boolean;
  discover: boolean;
  gmail: boolean;
  display: boolean;
  // maps: boolean;  // Not yet supported in Google Ads API v22/v23
}

export interface SelectedAudience {
  resource_name: string;
  audience_name: string;
  audience_type: string;
}

export interface DemandGenSettings {
  channelSettings: DemandGenChannelSettings;
  optimizedTargeting: boolean;
  initialAudiences: SelectedAudience[];
  demographicTargeting: DemographicSettings;
}

export const DEFAULT_DEMAND_GEN_CHANNEL_SETTINGS: DemandGenChannelSettings = {
  channelStrategy: 'ALL_CHANNELS',
  youtubeInStream: true,
  youtubeInFeed: true,
  youtubeShorts: true,
  discover: true,
  gmail: true,
  display: true, // ALL_CHANNELS includes Display (partner networks)
  // maps: true,  // Not yet supported in Google Ads API v22/v23
};

export const DEFAULT_DEMAND_GEN_SETTINGS: DemandGenSettings = {
  channelSettings: DEFAULT_DEMAND_GEN_CHANNEL_SETTINGS,
  optimizedTargeting: true, // Google recommends optimized targeting on by default
  initialAudiences: [],
  demographicTargeting: DEFAULT_DEMOGRAPHIC_SETTINGS,
};
